import { useEffect, useState } from "react";
import "@/App.css";
import axios from "axios";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import Privacy from "@/pages/Privacy";
import { Toaster } from "sonner";
import { registerServiceWorker } from "@/lib/push";

const RegionBlock = () => (
  <div
    data-testid="region-block-screen"
    className="fixed inset-0 z-[10000] flex items-center justify-center bg-[#0a1526] text-white px-6"
  >
    <div className="max-w-md text-center">
      <div className="mx-auto mb-6 flex h-14 w-14 items-center justify-center rounded-2xl border border-white/10 bg-[#12233c]">
        <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#60A5FA" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10" />
          <path d="M4.9 4.9l14.2 14.2" />
        </svg>
      </div>
      <h1 className="font-display font-bold text-2xl sm:text-3xl tracking-tight">
        This site isn't available in your region
      </h1>
      <p className="text-white/50 mt-4 leading-relaxed">
        Access to Link-Lite Data LLC is currently restricted in your location.
      </p>
    </div>
  </div>
);

function App() {
  const [blocked, setBlocked] = useState(false);

  useEffect(() => {
    document.documentElement.classList.add("dark");
    registerServiceWorker();

    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/api/geo`)
      .then(({ data }) => {
        if (data?.blocked) setBlocked(true);
      })
      .catch(() => {});

    const path = window.location.pathname;
    if (!path.startsWith("/admin") && !localStorage.getItem("ll_no_track")) {
      axios
        .post(`${process.env.REACT_APP_BACKEND_URL}/api/track`, {
          path,
          referrer: document.referrer || "",
        })
        .catch(() => {});
    }
  }, []);

  return (
    <div className="App">
      <div className="grain-overlay" />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/privacy" element={<Privacy />} />
        </Routes>
      </BrowserRouter>
      {blocked && <RegionBlock />}
      <Toaster theme="dark" position="bottom-right" richColors />
    </div>
  );
}

export default App;
